import { formatStringForURL } from 'utils';
import site from 'config';

export const searchAction = {
  '@context': 'https://schema.org/',
  '@type': 'WebSite',
  name: 'Sikka App',
  url: site.siteMetadata.siteUrl + '/blog',
  potentialAction: {
    '@type': 'SearchAction',
    target: site.siteMetadata.siteUrl + '/blog?page={search_term_string}',
    'query-input': 'required name=search_term_string'
  }
};

export const webPage = {
  '@context': 'https://schema.org/',
  '@type': 'WebPage',
  headline: 'Blog',
  url: site.siteMetadata.siteUrl + '/blog'
};

export const collectionPage = {
  '@context': 'https://schema.org/',
  '@type': 'WebPage',
  '@type': 'CollectionPage',
  '@id': site.siteMetadata.siteUrl + '/blog',
  url: site.siteMetadata.siteUr + '/blog',
  name: 'Mobile Apps Blog  | Sikka App',
  datePublished: new Date('05-01-2020'.replace(/-/g, '/')).toISOString(),
  dateModified: new Date().toISOString(),
  description: site.siteMetadata.description,
  inLanguage: 'en-US',
  isPartOf: {
    '@type': 'WebSite',
    '@id': site.siteMetadata.siteUrl + '/#website',
    url: site.siteMetadata.siteUrl,
    name: 'Sikka App',
    description: site.siteMetadata.description,
    inLanguage: 'en-US',
    publisher: {
      '@type': 'Organization',
      '@id': site.siteMetadata.siteUrl + '/#organization',
      name: 'Sikka App',
      url: site.siteMetadata.siteUrl,
      sameAs: [
        'https://www.instagram.com/sikka_app/',
        'https://www.facebook.com/people/Sikka-App/100074959262484/'
      ],
      logo: {
        '@type': 'ImageObject',
        '@id': site.siteMetadata.siteUrl + '/#/schema/logo/image/',
        inLanguage: 'en-US',
        url: site.siteMetadata.logo,
        contentUrl: site.siteMetadata.logo,
        caption: 'Sikka App'
      },
      image: {
        '@type': 'ImageObject',
        '@id': site.siteMetadata.siteUrl + '/#/schema/logo/image/',
        inLanguage: 'en-US',
        url: site.siteMetadata.image,
        contentUrl: site.siteMetadata.image,
        caption: 'Sikka App'
      },
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: site.siteMetadata.siteUrl + '/blog?page=1'
        },
        'query-input': {
          '@type': 'PropertyValueSpecification',
          valueRequired: 'http://schema.org/True',
          valueName: 'search_term_string'
        }
      }
    }
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    '@id': site.siteMetadata.siteUrl + '/blog/#breadcrumb',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: {
          '@type': 'Thing',
          '@id': site.siteMetadata.siteUrl
        }
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Blog'
      }
    ]
  }
};

export const breadCrumbSchema = (blog, path) => ({
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: site.siteMetadata.siteUrl
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Blog',
      item: site.siteMetadata.siteUrl + '/blog'
    },
    {
      '@type': 'ListItem',
      position: 3,
      name:
        blog?.data?.metaTitle || blog?.data?.customTitle || blog?.data?.title,
      item: site.siteMetadata.siteUrl + path
    }
  ]
});

export const authorBreadCrumbSchema = (author, path) => ({
  '@context': 'https://schema.org/',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: site.siteMetadata.siteUrl
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Blog',
      item: site.siteMetadata.siteUrl + '/blog'
    },
    {
      '@type': 'ListItem',
      position: 3,
      name: author?.name,
      item: site.siteMetadata.siteUrl + path
    }
  ]
});

function getListItem(index, name, blogBaseUrl) {
  return {
    '@type': 'ListItem',
    position: index + 1,
    name: name,
    url:
      site.siteMetadata.siteUrl +
      '/blog/' +
      blogBaseUrl +
      `#${formatStringForURL(name)}`
  };
}

export const generateItemListSchema = (blog, tableList) => {
  return {
    '@context': 'https://schema.org/',
    '@type': 'ItemList',
    url: site.siteMetadata.siteUrl + '/blog/' + formatStringForURL(blog.title),
    name: blog.metaTitle,
    description: blog.description,
    itemListElement: [
      ...tableList.map((item, index) =>
        getListItem(index, item, formatStringForURL(blog.title))
      )
    ]
  };
};

export const generateArticleSchema = (blog, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  mainEntityOfPage: {
    '@type': 'WebPage',
    '@id': site.siteMetadata.siteUrl + path
  },
  headline:
    blog?.data?.metaTitle || blog?.data?.customTitle || blog?.data?.title,
  description: blog?.data?.schemaDescription || blog?.data?.description,
  image: site.siteMetadata.siteUrl + blog?.data?.cover,
  author: {
    '@type': 'Person',
    name: blog?.data?.author,
    url:
      site.siteMetadata.siteUrl +
      '/blog/author/' +
      formatStringForURL(blog?.data?.author)
  },
  publisher: {
    '@type': 'Organization',
    name: 'Sikka App',
    logo: {
      '@type': 'ImageObject',
      url: site.siteMetadata.logo,
      height: '1600',
      width: '575'
    }
  },
  datePublished: blog?.data?.date,
  ...(blog?.data.dateModified ? { dateModified: blog.data.dateModified } : {})
});
